import { inject, Injectable } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { IAccessibleImageForm, IImageForm } from '../../entities/image-entity';
import {
  AccessibleImageId,
  DEFAULT_ACCESSIBLE_IMAGE_LOGO,
  IAccessibleImage,
  IImage,
  INormalText,
} from '@web/dtos';

@Injectable({
  providedIn: 'root',
})
export class ImageFormsFactoryService {
  private readonly formBuilder: FormBuilder = inject(FormBuilder);

  buildFormArray(
    entity: IAccessibleImage[] = [DEFAULT_ACCESSIBLE_IMAGE_LOGO]
  ): FormArray<FormGroup<IAccessibleImageForm>> {
    return this.formBuilder.array<FormGroup<IAccessibleImageForm>>(
      entity.map(
        (
          img: IAccessibleImage,
          index: number
        ): FormGroup<IAccessibleImageForm> => {
          return this.buildImageFormGroup(img, index);
        }
      )
    );
  }

  buildNormalImageFormGroup(image: IImage): FormGroup<IImageForm> {
    return this.formBuilder.group<IImageForm>({
      id: this.formBuilder.control(image.id ?? null),
      filename: this.formBuilder.nonNullable.control(image.filename ?? ''),
      fileExtension: this.formBuilder.nonNullable.control(
        image.fileExtension ?? ''
      ),
      createdAt: this.formBuilder.nonNullable.control(image.createdAt),
      isChecked: this.formBuilder.nonNullable.control(false),
      usage: this.formBuilder.control(image.usage ?? null),
    });
  }

  buildImageFormGroup(
    image: IAccessibleImage | undefined,
    position: number
  ): FormGroup<IAccessibleImageForm> {
    return this.formBuilder.group<IAccessibleImageForm>({
      id: this.formBuilder.control<AccessibleImageId | null>(image?.id || null),
      imageAlts: this.formBuilder.nonNullable.control<INormalText[]>(
        image?.imageAlts ?? []
      ),
      image: this.formBuilder.control<IImage | null>(image?.image ?? null),
      url: this.formBuilder.control<string | null>(image?.url || null),
      positionOrder: this.formBuilder.control<number>(
        image?.positionOrder ?? position
      ),
    });
  }
}
